<template>
    <svg width="17px" height="8px" viewBox="0 0 17 8" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Comps" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Public-Profile---Edit" transform="translate(-630.000000, -1768.000000)" stroke="#FFFFFF">
                <polyline id="Path-6-Copy" transform="translate(638.540190, 1771.770095) rotate(-180.000000) translate(-638.540190, -1771.770095) " points="631 1775.54019 638.54019 1768 646.08038 1775.54019"></polyline>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: "IconDown"
};
</script>